import { Injectable, inject } from '@angular/core';
import { ConfigGlobal } from '../../interfaces/config-global.interfaces';

@Injectable()
export class TransportConfigLoaderService {
  constructor() {
    const config = inject<ConfigGlobal>('config' as any);

    this.getConfig = config.getTransportConfig;
  }

  getConfig: (...args: any[]) => Promise<TransportConfig>;
}

/**
 * Represents a configuration object for the
 * Service to connect to, pub, and sub.
 */
export interface TransportConfig {
  // Which server?
  hostname: string; // 'localhost' or '127.0.0.1'
  host: string; // 'localhost' or '127.0.0.1'
  port: number; // 15675
  path: string; // 'ws'

  ssl: boolean; // false

  // What credentials?
  user?: string;
  pass?: string;

  retain: boolean;

  // How often to heartbeat?
  keepalive?: number;
}
